import { TestBed } from '@angular/core/testing';

import { SpyObject } from '../mock';
import { Token } from '../token';

/**
 * @internal
 */
export abstract class BaseSpec {
  public inject<T>(token: Token<T>): SpyObject<T> {
    return TestBed.inject ? TestBed.inject(token) : TestBed.get(token);
  }
}
